export default "__VITE_ASSET__BiFaA1fP__"